/**
 * @remix-run/server-runtime v1.0.5
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * A JSON response. Converts `data` to JSON and sets the `Content-Type` header.
 */
function json(data, init = {}) {
  let responseInit = init;

  if (typeof init === "number") {
    responseInit = {
      status: init
    };
  }

  let headers = new Headers(responseInit.headers);

  if (!headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json; charset=utf-8");
  }

  return new Response(JSON.stringify(data), { ...responseInit,
    headers
  });
}
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */

function redirect(url, init = 302) {
  let responseInit = init;

  if (typeof init === "number") {
    responseInit = {
      status: init
    };
  } else if (typeof responseInit.status === "undefined") {
    responseInit.status = 302;
  }

  let headers = new Headers(responseInit.headers);
  headers.set("Location", url);
  return new Response("", { ...responseInit,
    headers
  });
}

exports.json = json;
exports.redirect = redirect;
